<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        首页
        <small>首页</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#"> <i class="fa fa-dashboard"></i> 首页 </a>
        </li>
        <li class="active">首页</li>
      </ol>
    </section>
    <!-- Main content -->
    <section class="content">
      <!-- Main row -->
      <div class="row">
        <div class="col-sm-12">
          <div id="atptoolbar" style="margin-bottom: 10px">
            <router-link to="/stationAlarm">
              <button
                class="btn btn-danger"
                type="button"
                id="sys_alarm_button"
              >
                基站告警
              </button>
            </router-link>
            <router-link to="/stationWarning">
              <button
                class="btn btn-warning"
                type="button"
                id="sys_warning_button"
              >
                基站预警
              </button>
            </router-link>
            <label class="col-sm-2 control-label">开始时间：</label>
            <div class="col-sm-2">
              <input
                name="start"
                id="startTime"
                type="text"
                class="form-control"
                @click="datePicker('startTime')"
              />
            </div>
            <label class="col-sm-2 control-label">结束时间：</label>
            <div class="col-sm-2">
              <input
                name="end"
                id="endTime"
                type="text"
                class="form-control"
                @click="datePicker('endTime')"
              />
            </div>
          </div>
          <div id="line_content"></div>
        </div>
      </div>
      <!-- /.row (main row) -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
var xData = [];
var yData1 = [],
  yData2 = [],
  yData3 = [];
var startTime = Date.parse(new Date()) / 1000 - 2592000; //开始时间初始化
var endTime = Date.parse(new Date()) / 1000; //  结束时间初始化
var option = {};
var myChart = null;
export default {
  name: "",
  data() {
    return {};
  },
  components: {},
  mounted: function () {
    var self = this;
    self.echartsint();
    self.timeSelect();
  },
  methods: {
    timeSelect: function () {
      var self = this;
      (xData = []), (yData1 = []), (yData2 = []), (yData3 = []);
      self.global.axiosGet(
        self,
        "comm_active_power_avg/?start=" +
          startTime +
          "&end=" +
          endTime +
          "&interval=30",
        function (lineData) {
          console.log("折线图", lineData);
          if (lineData.error) {
            alert("参数有误");
            return;
          }
          if (lineData.length == 0) {
            option.xAxis[0].data = xData;
            option.series[0].data = yData1;
            option.series[1].data = yData2;
            option.series[2].data = yData3;
            myChart.setOption(option, true);
            return;
          }
          for (var m = 0; m < lineData[0].values.length; m++) {
            var time = lineData[0].values[m][0] * 1000;
            xData.push(
              new Date(time).toLocaleString("China", { hour12: false })
            );
          }
          for (var i = 0; i < lineData.length; i++) {
            for (var j = 0; j < lineData[i].values.length; j++) {
              if (lineData[i].tags.comm == "中国移动") {
                yData1.push(lineData[i].values[j][1]);
              } else if (lineData[i].tags.comm == "中国联通") {
                yData2.push(lineData[i].values[j][1]);
              } else {
                yData3.push(lineData[i].values[j][1]);
              }
            }
          }
          // console.log(xData);
          // console.log(yData1, yData2, yData3);
          option.xAxis[0].data = xData;
          option.series[0].data = yData1;
          option.series[1].data = yData2;
          option.series[2].data = yData3;
          myChart.setOption(option, true);
        }
      );
    },
    datePicker: function (elementId) {
      let self = this;
      WdatePicker({
        el: elementId,
        dateFmt: "yyyy-MM-dd", //日期格式，可以只显示年或年月，也可以额外显示时间
        onpicked: function () {
          var value = $("#" + elementId).val();
          var timeStamp = self.global.timeToStamp(value);
          console.log(elementId);
          if (elementId == "startTime") {
            startTime = timeStamp;
          } else {
            endTime = timeStamp;
          }
          console.log("time----", startTime, endTime);
          self.timeSelect();
        },
        oncleared: function () {
          self[elementId] = null;
        },
        isShowClear: true,
        readOnly: true,
      });
    },
    echartsint: function () {
      var self = this;
      myChart = self.echarts.init(document.getElementById("line_content"));
      console.log("myChart", myChart);
      option = {
        title: {
          top: "0",
          left: "center",
          text: "三大运营商基站平均功耗图",
          textStyle: {
            align: "center",
            color: "#FFFFFF",
            fontSize: 22,
          },
        },
        backgroundColor: "#1c2e40",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        legend: {
          x: "center",
          y: "40px",
          textStyle: {
            color: "#f2f2f2",
            fontSize: 13,
          },
          icon: "circle",
          data: ["中国移动", "中国联通", "中国电信"],
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            height: 20,
            left: "10%",
            right: "10%",
            bottom: "2%",
            start: 0,
            end: 100,
            textStyle: {
              color: "#d4ffff",
              fontSize: 11,
            },
          },
          {
            type: "inside",
          },
        ],
        grid: {
          right: "5%",
          bottom: "10%",
          left: "2%",
          top: "80px",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: xData,
            name: "时间",
            nameTextStyle: {
              color: "#d4ffff",
            },
            axisLine: {
              lineStyle: {
                color: "#0B4CA9",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#FFF",
                fontSize: 12,
              },
              //interval:0,
              //rotate:30
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "功耗",
            nameTextStyle: {
              color: "#d4ffff",
            },
            position: "left",
            axisLine: {
              lineStyle: {
                color: "#0B4CA9",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#0B4CA9",
              },
            },
            axisLabel: {
              color: "#d4ffff",
              fontSize: 12,
            },
          },
        ],
        series: [
          {
            name: "中国移动",
            type: "line",
            yAxisIndex: 0,
            symbolSize: 12,
            itemStyle: {
              normal: {
                color: "#0080cb",
              },
            },
            data: yData1,
          },
          {
            name: "中国联通",
            type: "line",
            yAxisIndex: 0,
            symbolSize: 12,
            itemStyle: {
              normal: {
                color: "#e90003",
              },
            },
            data: yData2,
          },
          {
            name: "中国电信",
            type: "line",
            yAxisIndex: 0,
            symbolSize: 12,
            itemStyle: {
              normal: {
                color: "#fff",
              },
            },
            data: yData3,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
  },
};
</script>
<style scoped>
#line_content {
  width: 100%;
  height: 78vh;
  background: #222d32;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/homepage/homepage.vue